export default __webpack_public_path__ + "static/media/mypic3.466f870b.jpg";